module.exports = __webpack_public_path__ + "static/media/redDocs.d3564202.svg";